import { useMemo } from 'react'
import { LoopsPage } from './LoopsPage'
import { createLoopDashboardStore } from './stores/loopDashboardStore'

export const LoopsPageContainer = () => {
	const store = useMemo(() => createLoopDashboardStore(), [])

	return <LoopsPage store={store} />
}
